import { initCodingScratchpad } from "coding_scratchpad.ts";
import { initTutor } from "tutor";
window.dodona.initTutor = initTutor;

window.dodona.initCodingScratchpad = initCodingScratchpad;
